// import { canUseDOM } from 'exenv';

export function videoPageLoading(resp = {}, store = {}) {
  return {
    type: 'VIDEO_PAGE_LOADING',
    videoPage: resp,
    store
  };
}

export function videoPageLoaded(resp = {}, store = {}) {
  return {
    type: 'VIDEO_PAGE_LOADED',
    videoPage: resp,
    store
  };
}

export function videoPageLoadError(error, store = {}) {
  return {
    type: 'VIDEO_PAGE_ERROR',
    videoPage: {
      isLoading: false,
      error: true,
      errorMessage: error ? error.message : 'no message'
    },
    store
  };
}
